import { render, staticRenderFns } from "./FieldInfo.vue?vue&type=template&id=08d029b1&scoped=true"
import script from "./FieldInfo.vue?vue&type=script&lang=js"
export * from "./FieldInfo.vue?vue&type=script&lang=js"
import style0 from "./FieldInfo.vue?vue&type=style&index=0&id=08d029b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d029b1",
  null
  
)

export default component.exports